import { Theme as AugmentedTheme } from '@mui/material';

import { makeStyles } from 'tss-react/mui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, DialogTitle, ErrorTemplate, ErrorTemplateCode, HtmlTrans } from 'web-library';
import { useHistory } from 'react-router-dom';
import Link from "@mui/material/Link";

import {typographyTheme} from "web-library/theme/helper/tssHelper"
const useStyles = makeStyles()((theme) =>
({
  statement: {
    marginBottom: theme.spacing(2),
  },
  link: {
     ...typographyTheme(theme, 'h4'),
    color: theme.color.link.linkDefault01,
    textDecoration: 'none',
  },
}));

const StatementOfResults = () => {
  const { classes } = useStyles();
  const { t } = useTranslation();
  const history = useHistory();

  return (
    <ErrorTemplate
      errorCode={'generic' as ErrorTemplateCode}
      title={
        <DialogTitle>
          <Box className={classes.statement}>
            <HtmlTrans
              i18nKey="components->>StatementOfResults.Statement1"
              values={{
                link: classes.link,
              }}
            />
          </Box>
          <HtmlTrans
            i18nKey="components->>StatementOfResults.Statement2"
            values={{
              link: classes.link,
            }}
          />
        </DialogTitle>
      }
      subtitle={
        <Link className={classes.link} onClick={() => history.push('/')}>
          {t('components->>StatementOfResults.Back to Homepage')}
        </Link>
      }
    />
  );
};

export default StatementOfResults;
